let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("43EiL")).then(() => parcelRequire('bKXd3'));